<template>
  <v-btn
    id="elCta-partner"
    :loading="isLoading"
    :class="btnClass"
    elevation="0"
    @click="handleClick "
  >
    {{ txt }}
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'BtnCta',
  props: {
    txt: {
      type: String
    },
    isLoading: {
      type: Boolean
    },
    isDisabled: {
      type: Boolean
    },
    isReverseTheme: {
      type: Boolean
    }
  },
  emits: ['click'],
  computed: {
    btnClass () {
      return {
        'main-app-cta': true,
        'disabled-cta': this.isDisabled,
        'active-cta': !this.isDisabled,
        'reverse-theme': this.isReverseTheme
      }
    }
  },
  methods: {
    handleClick (ev) {
      this.$emit('click', ev)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/btn/BtnCta.vue